import React from "react";
import FamilyManagement from "../../familyManagement/FamilyManagement";
import InstitutionScopeEmpty from "../components/InstitutionScopeEmpty";
import { useMasterAdmin } from "../MasterAdminContext";

const MasterAdminUsers = () => {
  const { selectedInstitutionId, institutions, loading } = useMasterAdmin();

  if (!loading && institutions.length === 0) {
    return (
      <InstitutionScopeEmpty
        title="No institutions yet"
        description="Create an institution workspace first, then return here to manage its families, parents, and children."
      />
    );
  }

  if (!selectedInstitutionId) {
    return (
      <InstitutionScopeEmpty
        title="Loading institutions..."
        description="Please wait while institution workspaces are loaded."
      />
    );
  }

  return (
    <FamilyManagement
      institutionIdOverride={selectedInstitutionId}
      masterAdminMode
    />
  );
};

export default MasterAdminUsers;
